export * from './date.tools';
export * from './mdiSvg';
export * from './phone.tools';
export * from './router.tools';
export const SITEKEY = process.env.VUE_APP_SITE_KEY;
